import { genQueryJsonStr } from '@/utils/querySchema'

export default function () {
  const activeEnum = {
    all: '',
    toProcess: '1',
    inProcess: '2',
    inAccount: '3',
    closed: '4',
  }
  function goPage(row, key, query = { }) {
    const path = '/workbench/rentOrder/list'
    const search = {
      tab: activeEnum[key],
    }
    Object.assign(query, search)
    this.$router.push(
      `${path}?query=${genQueryJsonStr(query)}`,
    )
  }
  function renderContent(row, key, query) {
    return this.$createElement('span', {
      class: 'item-active',
      on: {
        click: () => { goPage.call(this, row, key, query) },
      },
    }, row[key])
  }

  const columns = [
    {
      name: 'deptName',
      columnProps: {
        label: '部门',
        prop: 'deptName',
      },
    },
    {
      name: 'all',
      columnProps: {
        label: '全部订单数',
        prop: 'all',
      },
      render: ({ row }) => {
        return renderContent.call(this, row, 'all')
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'toProcess',
      columnProps: {
        label: '待履约订单数',
        prop: 'toProcess',
      },
      render: ({ row }) => {
        return renderContent.call(this, row, 'toProcess')
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'inProcess',
      columnProps: {
        label: '履约中订单数',
        prop: 'inProcess',
      },
      render: ({ row }) => {
        return renderContent.call(this, row, 'inProcess')
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'inAccount',
      columnProps: {
        label: '退车核算订单数',
        prop: 'inAccount',
      },
      render: ({ row }) => {
        return renderContent.call(this, row, 'inAccount')
      },
      columnHeaderTooltip: '',
    },
    {
      name: 'closed',
      columnProps: {
        label: '已关闭订单数',
        prop: 'closed',
      },
      render: ({ row }) => {
        return renderContent.call(this, row, 'closed')
      },
      columnHeaderTooltip: '',
    },
  ]
  return {
    columns,
  }
}
